<template>

  <div class="row">
    <div class="col-md-4 col-md-offset-4 col-sm-6 col-sm-offset-3">
      <form method="#" action="#">
        
        <div class="card">
          <div class="card-header">
            <img v-if="$store.state.isQCAS" src="static/img/qcas/QCAS_Ecctis_logo.jpg" />
            <h3 v-if="avatar" class="card-title">Impersonate</h3>
            <h3 v-else class="card-title">Login</h3>
          </div>
          <div class="card-content">
          
            <div v-if="avatar" class="form-group">
              <div class="form-control-static text-danger text-center">Login with your QC Admin credientials.<br/>After login you will be impersonating<br/><span style="font-size: 120%; font-weight: 700">{{avatar}}</span><br/>(Sessions last 15min)</div>
            </div>
            <div class="form-group">
              <label>Email address / Username</label>
              <input v-model="username" type="email" placeholder="Enter email" class="form-control input-no-border">
            </div>
            <div class="form-group">
              <label>Password</label>
              <input v-model="password" type="password" placeholder="Password" class="form-control input-no-border">
            </div>
            <div v-if="error" class="form-group">
              <div class="form-control-static text-danger text-center"><i class="fa fa-exclamation"></i>{{error}}</div>
            </div>
          </div>
          <div class="card-footer text-center">
            <button @click.prevent="login" type="submit" class="btn btn-fill btn-wd ">
              <i v-if="loggingIn" class="fa fa-cog fa-spin" aria-hidden="true"></i>
              <span v-else>Login</span>
            </button>
            
            <div class="forgot">
              <router-link to="/login/reset">Forgot your password?</router-link>
            </div>
          </div>
        </div>
        
        <div v-if="!partnerLogo && !$store.state.isQCAS"  class="card">
          <div class="card-content text-center">
          Don't have an account?<br/><br/>
            <router-link class="btn btn-wd btn-danger" :to="'/login/register?' + (atid ? 'atid='+atid : '') ">Register for free</router-link><br/>
          </div>
        </div>

      </form>
    </div>
  </div>
          
</template>
<script>  
  export default {
    props: {
      atid: String,
      partnerLogo: {type: String, default: null}
    },
    data () {
      return {
        username: null,
        password: null,
        loggingIn: false,
        error: this.$route.query.expired == 'true' ? "Your session has expired, please log in again" : null,
        avatar: this.$route.query.impersonate
      }
    },
    mounted () {
      if(this.partnerLogo) {
        this.$store.commit('setPartnerLogo', this.partnerLogo)
      }
    },
    methods: {
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      login: function () {
        this.loggingIn = true
        this.error = null
        this.$api.login(this.username, this.password, this.avatar)
          .then(response => {
            if(this.$store.state.isIndividual) {
              this.$api.getApplicationHistory({
                    status: ['OPEN'],
                    page: 0,
                    size: 500
                  })
              .then(response => {
                if(response.data.totalSize > 0) {
                  this.$router.push('/applications/open')
                } else {
                  if(this.$store.state.redirectPage == '/dashboard') {
                    this.$store.commit('setRedirectPage', '/wallet')
                  }
                  this.$router.push(this.$store.state.redirectPage || '/')
                }
                this.$store.commit('setRedirectPage', null)
              })
              .catch(error => {
                console.log(error)
              })
            } else {
              this.$router.push(this.$store.state.redirectPage || '/')
              this.$store.commit('setRedirectPage', null)
            }
          })
          .catch(error => {
            var status = ((error||{}).response||{}).status
            if(status == 401) {
              this.error = 'Incorrect username or password'
            } else {
              console.log(error)
              this.error = 'An unknown error occurred, please try again or report this error.'
            }
            this.loggingIn = false
          })
      }
    },
    beforeDestroy () {
      this.closeMenu()
    }
  }
</script>
<style>
</style>
